import React, { useMemo } from 'react';
import Overview from './overview/Overview';
import CohortBenchmarking from './cohort-benchmarking/CohortBenchmarking';
import { IVesselFormData } from '../../../../shared/sharedTypes';
import DynamicTab from '../../../../shared/components/tabs/DynamicTab';
import { ITabPage } from '../../../../shared/components/tabs/ITabPage';
import LoadingSpinner from '../../../../shared/components/loading-spinner/LoadingSpinner';

const Vessel: React.FC<ITabPage<IVesselFormData>> = ({ ...props }) => {
	const pageContent = useMemo(() => {
		return (!props.data && <LoadingSpinner size="md" spinnerClassName="p-2" />) || <Overview data={props.data} isFleet={props.isFleet} />;
	}, [props.data]);

	const tabs = [
		{
			id: 'overview',
			label: 'Overview',
			content: pageContent,
		},
		{
			id: 'cohort-benchmarking',
			label: 'Cohort Benchmarking',
			content: <CohortBenchmarking data={props.data} />,
		},
	];

	return (
		<div className="flex flex-col w-full h-full">
			{props.hideTab ? pageContent : <DynamicTab items={tabs} tabColor="msi-chart-midgreen" giveSpace={props.giveSpace} />}
		</div>
	);
};

export default Vessel;
